'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' });

var ModeComment = function ModeComment(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ModeComment = (0, _pure2.default)(ModeComment);
ModeComment.muiName = 'SvgIcon';

exports.default = ModeComment;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ModeComment.js
// module id = 2615
// module chunks = 0